import { getDiagnosticReport } from "../../../services/reportGenerationService";
import SRS from 'Services/StudentRecordService';

export function fetchReport (studentId, locale, classId) {

  // start both request together since they don't depend on each other
  const report = getDiagnosticReport(studentId.value, locale)
  const scores = SRS.getReadingRopeData({ classId, studentId: studentId.value, locale })

  return Promise.all([report, scores]).then(values => {
    const [reportData, scoreData] = values
    return [reportData.data.studentReport.diagnosis, scoreData]
  }).catch((error)=>{
    throw(error)
  })
}

export default {
  fetchReport,
}